import {
  CancelReasonTypesResponse,
  getCancelReasonTypes,
  SuccessResponse,
} from '@back-office/http';
import { cast } from 'mobx-state-tree';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import { ResponseMessage } from '../../constants';
import { handleNotAuthorized, Self } from '../common';

function* cancelReasonTypesRequest(
  self: Self
): Generator<Promise<FlowReturn<CancelReasonTypesResponse>>> {
  self.isLoading = true;
  try {
    const response = yield getCancelReasonTypes();
    const { data, status } = (response as CancelReasonTypesResponse).data;
    if (status.code === 1000) {
      self.cancelReasonTypes.reset();
      self.cancelReasonTypes.list = cast(data);
      return Promise.resolve(ResponseMessage.OK);
    }
    if (status.code === 9500) {
      return handleNotAuthorized(self, response as SuccessResponse);
    }
    self.alert.title = status.messages[0];
    self.alert.open = true;
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    self.alert.title = 'login_form.internal_server_error';
    self.alert.open = true;
    return Promise.reject(new Error(e.message));
  } finally {
    self.isLoading = false;
  }
}

export default cancelReasonTypesRequest;
